'use client';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useTranslations } from '@/hooks/useTranslations';
import { ImportInvoiceForm } from './import-invoice-form';
import { useInvoiceContext } from '@/contexts/invoice-context';

export const ImportInvoicePopup = () => {
  const { state: invoice, dispatch } = useInvoiceContext();

  const t = useTranslations('ImportInvoice');

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      dispatch({ type: 'CLOSE_IMPORT_INVOICE_POPUP' });
    }
  };

  return (
    <Sheet
      open={invoice.isImportInvoicePopupOpen}
      onOpenChange={handleOpenChange}
    >
      <SheetContent className="bg-white dark:bg-black sm:max-w-xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle className="text-left">{t('title')}</SheetTitle>
          <SheetDescription>{t('description')}</SheetDescription>
        </SheetHeader>

        <div className="grid gap-4 p-4">
          <ImportInvoiceForm />
        </div>
      </SheetContent>
    </Sheet>
  );
};
